angular.module('common.services').service('nominatimLookUp', [
  '$http',
  '$timeout',
  '$q',
  function ($http, $timeout, $q) {
    var pendingRequestTimouts = {}
    var hasPendingRequest = false
    var canceller = null
    this.querySearch = query =>
      new Promise(function (resolve, reject) {
        if (hasPendingRequest && canceller) {
          canceller.resolve()
        }
        hasPendingRequest = true
        $timeout(function () {
          canceller = $q.defer()
          var requestJson = {
            method: 'GET',
            url:
              'https://nominatim.openstreetmap.org/search.php?format=json&q=' +
              query,
            timeout: canceller.promise
          }
          $http(requestJson).then(
            function (response) {
              resolve(response.data)
              hasPendingRequest = false
            },
            function (response) {
              resolve([])
              hasPendingRequest = false
            }
          )
        })
      })
    this.reverseLookup = input =>
      new Promise(function (resolve, reject) {
        $timeout(function () {
          var cancellerTemp = $q.defer()
          var requestJson = {
            method: 'GET',
            url: `https://revgeocode.search.hereapi.com/v1/revgeocode?apiKey=${MAPS_HERE_API_KEY}&types=address&limit=1&at=${input.lat},${input.lon}&lang=en`,
            timeout: cancellerTemp.promise
          }
          var requestId = performance.now() // eslint-disable-line no-undef
          pendingRequestTimouts[requestId] = cancellerTemp
          $http(requestJson).then(
            function (response) {
              // Example response:
              // {
              //   "items": [
              //   {
              //     "title": "עומר 17, 2196315 כרמיאל, ישראל",
              //     "id": "here:af:streetsection:EUv2wth9VbrsdCVqPzieNB:CgcIBCD22vFzEAEaAjE3",
              //     "resultType": "houseNumber",
              //     "houseNumberType": "PA",
              //     "address": {
              //       "label": "עומר 17, 2196315 כרמיאל, ישראל",
              //       "countryCode": "ISR",
              //       "countryName": "ישראל",
              //       "stateCode": "Z",
              //       "state": "צפון",
              //       "county": "עכו",
              //       "city": "כרמיאל",
              //       "street": "עומר",
              //       "postalCode": "2196315",
              //       "houseNumber": "17"
              //     },
              //     "position": {
              //       "lat": 32.91216,
              //       "lng": 35.27431
              //     },
              //     "access": [
              //       {
              //         "lat": 32.91199,
              //         "lng": 35.27428
              //       }
              //     ],
              //     "distance": 1,
              //     "mapView": {
              //       "west": 35.27333,
              //       "south": 32.91181,
              //       "east": 35.27526,
              //       "north": 32.91201
              //     }
              //   }
              // ]
              // }
              response.data.items.length > 0
                ? resolve(response.data.items[0])
                : resolve({})
              delete pendingRequestTimouts[requestId]
            },
            function (response) {
              resolve({})
              delete pendingRequestTimouts[requestId]
            }
          )
        })
      })
    this.reverseLookupMultiple = input =>
      new Promise((resolve, reject) => {
        $http({
          method: 'POST',
          headers: {
            'Content-Type': undefined
          },
          url: `https://multi-revgeocode.search.hereapi.com/v1/multi-revgeocode?apiKey=${MAPS_HERE_API_KEY}&types=address&limit=1&lang=en`,
          data: input
        }).then(
          response => resolve(response.data),
          response => reject(console.error(response))
        )
      })
  }
])
